// import { sidebarItems } from "data/data";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Collapse } from "reactstrap";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import type { RootState } from "store";
import { AnyAction, createSelector, ThunkDispatch } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { sidebarItems } from "data/data";
interface SidebarItemsProps {
  id: number,
  icon?: string,
  path?: string,
  label?: string,
  constant: string,
  badgeName?: string;
  badgeColor?: string;
  iseditaccess?: boolean;
  moduleaccess?: boolean;
  
}

interface SidebarMenuProps {
  sidebarItems: SidebarItemsProps[]; // You had this 'data/data'
}
const SidebarMenu = ({ sidebarItems }: SidebarMenuProps) => {

  const { t } = useTranslation();
  const [openMenus, setOpenMenus] = useState<{ [key: number]: boolean }>({});

  const selectLoginState = (state: RootState) => state.Login;

  // const selectUserData = createSelector(selectLoginState, (login) => ({
  //   useraccessrights: login.useraccessrights
  // }));
 let useraccessrights = sidebarItems
  // const { useraccessrights } = useSelector(selectUserData);


  // const data = useSelector(selectUserData)

  const toggleSubMenu = (id: number) => {
    setOpenMenus((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };


  return (
    <ul className="navbar-nav pt-4" id="navbar-nav">
      {useraccessrights
        .filter((item: any) => item.moduleaccess)
        .map((item: any, index: number) => (
          <li className="nav-item" key={`menu-${index}`}>
            {item.subItems ? (
              <SubItemsMenu
                openMenus={openMenus}
                toggleSubMenu={toggleSubMenu}
                item={item}
                t={t}
              />
            ) : (
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `nav-link menu-link d-flex align-items-center gap-2 ${isActive ? "active" : ""
                  }`
                }
              >
                <i className={item.icon}></i>
                <span style={{ whiteSpace: 'nowrap' }}>{t(item.label)}</span>
              </NavLink>
            )}
          </li>
        ))}
    </ul>
  );
};

interface SubItemMenuProps {
  openMenus: { [key: number]: boolean };
  toggleSubMenu: (id: number) => void;
  item: any;
  t: (key: string) => string;
}

const SubItemsMenu = ({
  openMenus,
  toggleSubMenu,
  item,
  t,
}: SubItemMenuProps) => {
  const location = useLocation();

  return (
    <>
     <Link
  to="#"
  onClick={(e) => {
    e.preventDefault();
    toggleSubMenu(item.id);
  }}
  className={`nav-link menu-link d-flex align-items-center justify-content-between ${
    openMenus[item.id] ? "active" : ""
  }`}
  role="button"
>

        <span style={{ whiteSpace: 'nowrap' }}>
          {item.icon && <i className={item.icon + " me-2"}></i>}
          {t(item.label)}
        </span>

        <i
          className={`mdi transition-icon ${openMenus[item.id] ? "mdi-chevron-down" : "mdi-chevron-right"
            }`}
          style={{ marginLeft: '1rem' }}
        ></i>
      </Link>
      <Collapse isOpen={openMenus[item.id]} className="menu-dropdown">
        <ul className="nav flex-column ms-3">
          {item.subItems.map((sub: any) => (
            <li className="nav-item" key={sub.id}>
              {sub.subItems ? (
                <SubItemsMenu
                  openMenus={openMenus}
                  toggleSubMenu={toggleSubMenu}
                  item={sub}
                  t={t}
                />
              ) : (
                <Link
                  to={sub.path}
                  className={`nav-link ${location.pathname === sub.path ? "active" : ""
                    }`}
                >
                  <span></span> <span style={{ whiteSpace: 'nowrap' }}>{t(sub.label)}</span>
                </Link>
              )}
            </li>
          ))}
        </ul>
      </Collapse>
    </>
  );
};

export default SidebarMenu;
